import Trans from "./Trans";
import useTranslation from "./useTranslation";

export { Trans, useTranslation };
